module.exports = __webpack_public_path__ + "img/university-app-articles.0f321d16.png";